import Footer from "../../components/shared/Footer"
import Header from "../../components/shared/Header"
import Resource from "../../images/Resources.png"
import { useState } from "react";
import Glossary from "../../images/Glossary (1).png"
import Glossary2 from "../../images/Glossary (2).png"
import Glossary3 from "../../images/Glossary (3).png"
import Glossary4 from "../../images/Glossary (4).png"
import Glossary5 from "../../images/Glossary (5).png"
import Glossary6 from "../../images/Glossary (6).png"
import webinar1 from "../../images/Webinars (1).png"
import webinar2 from "../../images/Webinars (2).png"
import webinar3 from "../../images/Webinars (3).png"
function Resources() {
  const [formData, setFormData] = useState({
    email: '',
    message: ''
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.email) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email is invalid';
    }
    if (!formData.message) {
      newErrors.message = 'Message is required';
    }
    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validateForm();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setIsSubmitting(true);
    try {
      // Add your API endpoint here
      // const response = await fetch('/api/feedback', {
      //   method: 'POST',
      //   headers: { 'Content-Type': 'application/json' },
      //   body: JSON.stringify(formData)
      // });

      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 1000));

      setSubmitStatus('success');
      setFormData({ email: '', message: '' });
      setTimeout(() => setSubmitStatus(null), 3000);
    } catch (error) {
      setSubmitStatus('error');
      setTimeout(() => setSubmitStatus(null), 3000);
    } finally {
      setIsSubmitting(false);
    }
  };


  const articlesData = [
    {
      id: 1,
      image: Glossary,
      title: "Carbon Incentive ",
      description: "Our insights cover topics like innovative eco-friendly technologies, mindful consumption, circular economies, renewable energy, and sustainable transportation. ",
      readMoreLink: "/carbon-incentive"
    },
    {
      id: 2,
      image: Glossary2,
      title: "Carbon Program and Initiatives ",
      description: "Our insights cover topics like innovative eco-friendly technologies, mindful consumption, circular economies, renewable energy, and sustainable transportation. ",
      readMoreLink: "/carbon-programs-initiatives"
    },
    {
      id: 3,
      image: Glossary3,
      title: "Emissions Management",
      description: "Our insights cover topics like innovative eco-friendly technologies, mindful consumption, circular economies, renewable energy, and sustainable transportation. ",
      readMoreLink: "/EmissionsManagement"
    },
    {
      id: 4,
      image: Glossary4,
      title: "Measurement & Tracking",
      description: "Our insights cover topics like innovative eco-friendly technologies, mindful consumption, circular economies, renewable energy, and sustainable transportation. ",
      readMoreLink: "/measurement-tracking "
    },
    {
      id: 5,
      image: Glossary5,
      title: "Project Types",
      description: "Our insights cover topics like innovative eco-friendly technologies, mindful consumption, circular economies, renewable energy, and sustainable transportation. ",
      readMoreLink: "/project-types"
    },
    {
      id: 6,
      image: Glossary6,
      title: "Verification & Validation",
      description: "Our insights cover topics like innovative eco-friendly technologies, mindful consumption, circular economies, renewable energy, and sustainable transportation. ",
      readMoreLink: "/verification-validation"
    }
  ];
  const articlesData2 = [
    {
      id: 1,
      image: webinar1,
      title: "Trends in Sustainable Living ",
      description: "Our insights cover topics like innovative eco-friendly technologies, mindful consumption, circular economies, renewable energy, and sustainable transportation. ",
      readMoreLink: "/articles/carbon-credits-guide"
    },
    {
      id: 2,
      image: webinar2,
      title: "Charting a Sustainable Course",
      description: "Our insights cover topics like innovative eco-friendly technologies, mindful consumption, circular economies, renewable energy, and sustainable transportation. ",
      readMoreLink: "/articles/technology-sustainable-practices"
    },
    {
      id: 3,
      image: webinar3,
      title: "Green Horizon Insights",
      description: "Our insights cover topics like innovative eco-friendly technologies, mindful consumption, circular economies, renewable energy, and sustainable transportation. ",
      readMoreLink: "/articles/industrial-emissions-solutions"
    },

  ];

  const ArticleCard = ({ image, title, description, readMoreLink }) => {
    return (
      <div className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
        {/* Image Container */}
        <div className="relative overflow-hidden">
          <img
            src={image}
            alt={title}
            className="w-full h-[282px] object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300" />
        </div>

        {/* Content */}
        <div className="p-6 flex flex-col gap-4">
          <div className="flex flex-col gap-3">
            {/* Title */}
            <h3 className=" text-[18px] font-semibold leading-[26px] text-[#3B3B3B] line-clamp-2 min-h-[52px]">
              {title}
            </h3>

            {/* Description */}
            <p className=" text-[14px] font-normal leading-[20px] text-[#898989] line-clamp-4 min-h-[80px]">
              {description}
            </p>
          </div>

          {/* Read More Link */}
          <div className="flex justify-end mt-2">
            <a href={readMoreLink}

              className="group/link flex items-center gap-2 text-[#006633] hover:text-[#005528] transition-colors duration-300"
            >
              <span className=" text-[14px] font-medium leading-[20px]">
                READ MORE
              </span>
              <svg width="9" height="18" viewBox="0 0 9 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.21857 9L1 14.0001L2.04357 15L7.78392 9.49994C7.92227 9.36733 8 9.18751 8 9C8 8.81249 7.92227 8.63267 7.78392 8.50006L2.04357 3L1 3.99988L6.21857 9Z" fill="#006633" stroke="#006633" stroke-width="0.5" />
              </svg>

            </a>
          </div>
        </div>
      </div>
    );
  };
  const ArticleCard1 = ({ image, title, description, readMoreLink }) => {
    return (
      <div className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
        {/* Image Container */}
        <div className="relative overflow-hidden">
          <img
            src={image}
            alt={title}
            className="w-full h-[282px] object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300" />
        </div>

        {/* Content */}
        <div className="p-6 flex flex-col gap-4">
          <div className="flex flex-col gap-3">
            {/* Title */}
            <h3 className=" text-[18px] font-semibold leading-[26px] text-[#3B3B3B] line-clamp-2 min-h-[52px]">
              {title}
            </h3>

            {/* Description */}
            <p className=" text-[14px] font-normal leading-[20px] text-[#898989] line-clamp-4 min-h-[80px]">
              {description}
            </p>
          </div>

          {/* Read More Link */}
          <div className="flex justify-end mt-2">
            <a
              href={readMoreLink}
              className="group/link flex items-center gap-2 text-[#006633] hover:text-[#005528] transition-colors duration-300"
            >
              <span className=" text-[14px] font-medium leading-[20px]">
                WATCH NOW
              </span>
              <svg width="9" height="18" viewBox="0 0 9 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.21857 9L1 14.0001L2.04357 15L7.78392 9.49994C7.92227 9.36733 8 9.18751 8 9C8 8.81249 7.92227 8.63267 7.78392 8.50006L2.04357 3L1 3.99988L6.21857 9Z" fill="#006633" stroke="#006633" stroke-width="0.5" />
              </svg>

            </a>
          </div>
        </div>
      </div>
    );
  };
  const firstRowArticles = articlesData.slice(0, 3);
  const firstRowArticles1 = articlesData2.slice(0, 3);
  const secondRowArticles = articlesData.slice(0, 6);
  return (

    <>
      <Header />

      {/* resources hero */}
      <section className="relative w-full  bg-white mb-0">
        {/* Main container with exact positioning from Figma */}
        <div className="relative w-full max-w-[1440px] mx-auto lg:pt-[119px] pt-[62px]">

          {/* Content container */}
          <div className="relative px-4 sm:px-6 lg:px-0">

            {/* Text content centered */}
            <div className="flex flex-col items-center gap-6 mb-12 lg:mb-16">
              {/* Main heading */}
              <h1 className="text-[30px] md:text-[48px] lg:text-[64px] font-normal  text-center text-[#141414]  mx-auto">
                Hub of Valuable Insights and Knowledge
              </h1>

              {/* Subheading */}
              <p className="text-[18px] md:text-[24px] lg:text-[28px] font-normal leading-[1.5] text-center text-[#3B3B3B]  w-full mx-auto px-4">
                Your Source for Environmental Information and Wisdom                </p>
            </div>

            {/* Background image container */}
            <div className="relative w-full max-w-[1200px] mx-auto rounded-[20px] overflow-hidden lg:min-h-[300px]">
              <img src={Resource}
                className="w-full h-full bg-cover bg-center bg-no-repeat rounded-[20px]"

              >
                {/* Optional overlay or content inside the image */}

              </img>
            </div>

          </div>
        </div>
      </section>






      <section className="w-full bg-white pb-16 pt-12 lg:py-20">
        <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">

          {/* Main Container */}
          <div className="flex flex-col gap-8 lg:gap-10">

            {/* Glossary Title */}
            <h2 className=" text-[28px] sm:text-[32px] lg:text-[36px] font-medium leading-[1.2] lg:leading-[43px] text-[#141414]">
              Glossary
            </h2>

            {/* Articles Grid */}
            <div className="flex flex-col gap-6 lg:gap-8">

              {/* First Row */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
                {/* {firstRowArticles.map((article) => (
                <ArticleCard1
                  key={article.id}
                  image={article.image}
                  title={article.title}
                  description={article.description}
                  readMoreLink={article.readMoreLink}
                />
              ))} */}
              </div>

              {/* Second Row */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
                {secondRowArticles.map((article) => (
                  <ArticleCard
                    key={article.id}
                    image={article.image}
                    title={article.title}
                    description={article.description}
                    readMoreLink={article.readMoreLink}
                  />
                ))}
              </div>

            </div>

          </div>

        </div>
      </section>

      <section className="w-full bg-white py-16 lg:py-20">
        <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">

          {/* Main Container */}
          <div className="flex flex-col gap-8 lg:gap-10">

            {/* Glossary Title */}
            <h2 className="text-[28px] sm:text-[32px] lg:text-[36px] font-medium leading-[1.2] lg:leading-[43px] text-[#141414]">
              Webinars
            </h2>

            {/* Articles Grid */}
            <div className="flex flex-col gap-6 lg:gap-8">

              {/* First Row */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
                {firstRowArticles1.map((article) => (
                  <ArticleCard1
                    key={article.id}
                    image={article.image}
                    title={article.title}
                    description={article.description}
                    readMoreLink={article.readMoreLink}
                  />
                ))}
              </div>


            </div>

          </div>

        </div>
      </section>

      <section className="w-full bg-white py-16 lg:py-20">
        <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">

          {/* Frame 2147228708 - Main container */}
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-[163px]">

            {/* Left side - Text content */}
            <div className="flex flex-col gap-2 lg:gap-[8px] w-full lg:w-[459px]">
              <h3 className=" text-[20px] sm:text-[22px] lg:text-[24px] font-medium leading-[1.5] text-[#141414]">
                We'd love to hear your thoughts or feedback!
              </h3>
              <p className=" text-[14px] sm:text-[15px] lg:text-[16px] font-normal leading-[1.5] text-[#3B3B3B]">
                Feel free to reach out by writing to us.
              </p>
            </div>

            {/* Right side - Form */}
            <form onSubmit={handleSubmit} className="flex flex-col gap-6 lg:gap-[32px] w-full lg:w-[578px]">

              {/* Email Field */}
              <div className="flex flex-col gap-3 lg:gap-[16px] w-full">
                {/* Label with asterisk */}
                <div className="flex items-center gap-1">
                  <label className=" text-[12px] font-medium leading-[14px] text-[#141414]">
                    Email Address
                  </label>
                  <span className="text-red-500 text-[10px]">*</span>
                </div>

                {/* Input field */}
                <div className={`relative ${errors.email ? 'mb-4' : ''}`}>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter email address"
                    className={`w-full px-3 py-3 lg:px-4 lg:py-3 text-[12px] lg:text-[14px] font-normal leading-[1.2] text-[#141414] placeholder:text-[#898989] border rounded-xl focus:outline-none focus:border-[#006633] transition-colors ${errors.email ? 'border-red-500' : 'border-[#898989]'
                      }`}
                    style={{ borderWidth: '0.5px' }}
                  />
                  {errors.email && (
                    <p className="absolute -bottom-5 left-0 text-red-500 text-[10px] mt-1">
                      {errors.email}
                    </p>
                  )}
                </div>
              </div>

              {/* Message Field */}
              <div className="flex flex-col gap-3 lg:gap-[16px] w-full">
                {/* Label with asterisk */}
                <div className="flex items-center gap-1">
                  <label className=" text-[12px] font-medium leading-[14px] text-[#141414]">
                    Message
                  </label>
                  <span className="text-red-500 text-[10px]">*</span>
                </div>

                {/* Textarea field */}
                <div className={`relative ${errors.message ? 'mb-4' : ''}`}>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Type your message here..."
                    rows={6}
                    className={`w-full px-3 py-3 lg:px-4 lg:py-3 text-[12px] lg:text-[14px] font-normal leading-[1.5] text-[#141414] placeholder:text-[#898989] border rounded-xl focus:outline-none focus:border-[#006633] transition-colors resize-vertical ${errors.message ? 'border-red-500' : 'border-[#898989]'
                      }`}
                    style={{ borderWidth: '0.5px', minHeight: '175px' }}
                  />
                  {errors.message && (
                    <p className="absolute -bottom-5 left-0 text-red-500 text-[10px] mt-1">
                      {errors.message}
                    </p>
                  )}
                </div>
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                disabled={isSubmitting}
                className={`w-full bg-[#006633] hover:bg-[#005528] active:bg-[#004420] rounded-xl px-4 py-3 lg:py-4 transition-colors duration-300 flex items-center justify-center gap-2 ${isSubmitting ? 'opacity-70 cursor-not-allowed' : ''
                  }`}
                style={{ height: '67px' }}
              >
                {isSubmitting ? (
                  <>
                    <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    <span className=" text-[14px] lg:text-[16px] font-medium leading-[19px] text-white">
                      Sending...
                    </span>
                  </>
                ) : (
                  <span className=" text-[14px] lg:text-[16px] font-medium leading-[19px] text-white">
                    Send Message
                  </span>
                )}
              </button>

              {/* Submit Status Messages */}
              {submitStatus === 'success' && (
                <div className="bg-green-50 border border-green-200 rounded-lg p-3 text-center">
                  <p className="text-green-600 text-sm font-medium">
                    ✓ Thank you for your feedback! We'll get back to you soon.
                  </p>
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="bg-red-50 border border-red-200 rounded-lg p-3 text-center">
                  <p className="text-red-600 text-sm font-medium">
                    ✗ Sorry, something went wrong. Please try again later.
                  </p>
                </div>
              )}

            </form>

          </div>

        </div>
      </section>
      <Footer />
    </>
  )
}

export default Resources